import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import LinkDialog from "../LinkDialog";
import SearchView from "../../widgets/SearchView";
import Prompt from '../../widgets/Prompt';
import HETLecturerSupportSetupSearchForm from '../program/HETLecturerSupport/HETLecturerSupportSetupSearchForm';
import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";


const headCells = [
    { id: 'HETLecturerSupportCode', numeric: false, disablePadding: true, label: 'HET Lecturer Support Code' },
    { id: 'HETLecturerSupportTitle', numeric: false, disablePadding: true, label: 'HET Lecturer Support Title' },
    { id: 'HETLecturerSupportStatus', numeric: false, disablePadding: true, label: 'HET Lecturer Support Status' },
    { id: 'CommencementDate', numeric: false, disablePadding: true, label: 'Commencement Date' },
    { id: 'CompletionDate', numeric: false, disablePadding: true, label: 'Completion Date' },
    { id: 'SDLNumber', numeric: false, disablePadding: true, label: 'Employer' }
];



const utils = new ViewUtils();
const toolbarRef = React.createRef();

class LearnerHETLecturerSupport extends Component {
    constructor(props) {
        super(props);

        this.searchParameters = !utils.isNull(this.props.location.state.learnerID) ? [
            { Name: "HETLecturerSupportCode", Value: "" },
            { Name: "HETLecturerSupportTitle", Value: "" },
            { Name: "ProgrammeID", Value: this.props.programmeId },
            { Name: "LearnerID", Value: this.props.location.state.learnerID }
        ]
            :
            [
                { Name: "HETLecturerSupportCode", Value: "" },
                { Name: "HETLecturerSupportTitle", Value: "" },
                { Name: "LearnerID", Value: this.props.location.state.learnerID }
            ];

        let model = !utils.isNull(this.props.location.state.learnerID) ?
            {
                HETLecturerSupportCode: "",
                HETLecturerSupportTitle: "",
                ProgrammeID: this.props.programmeId,
                LearnerID: this.props.location.state.learnerID

            }
            :
            {
                HETLecturerSupportCode: "",
                HETLecturerSupportTitle: "",
                LearnerID: this.props.location.state.learnerID
            }


        if (!utils.isNull(props.exclusions)) {
            model.Exclusions = props.exclusions;
            this.searchParameters.push({ Name: "Exclusions", Value: props.exclusions });
        }


        this.state =
        {
            model: model,
            keyUpSwitch: false,
            selectedLearnerHETLecturerSupport: null
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'view', label: '', tooltip: 'View', icon: 'ViewIcon', visible: this.props.menuPermissionItem.View },
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: "", tooltip: "Remove HET Lecturer Support", icon: "DeleteIcon", visible: this.props.menuPermissionItem.Delete },
                        { id: 'generate', label: 'Generate HET Lecturer Support Contract', icon: 'DownloadIcon', path: false, tooltip: 'Generate HET Lecturer Support Contract', disabled: utils.isNull(this.state.selectedLearnerHETLecturerSupport) }
                    ]
                }
            ]
        }

        //TODO: Add url for HETLecturerSupport removal
        this.deleteUrl = ""
    }


    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/learner',
                state: {
                    selection: this.props.location.state.learnerID
                }
            });
        }
        else if (buttonId === "add") {
            this.props.history.push({
                pathname: '/AddLearnerHETLecturerSupport',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    HETLecturerSupportID: null,
                    hideFields: true,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem
                }
            })
        }
        else if (buttonId === "edit") {
            console.log(this.state.selectedLearnerHETLecturerSupport[0].Id);
            this.props.history.push({
                pathname: '/AddLearnerHETLecturerSupport',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    HETLecturerSupportID: this.state.selectedLearnerHETLecturerSupport[0].Id,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem
                }
            })
        }
        else if (buttonId === "view") {
            this.props.history.push({
                pathname: '/AddLearnerHETLecturerSupport',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    HETLecturerSupportID: this.state.selectedLearnerHETLecturerSupport[0].Id,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem,
                    viewOnly: true
                }
            })
        }

        else if (buttonId === "generate") {
            this.generateDocuments();
            toolbarRef.current.setButtonDisabled("edit", true);
            toolbarRef.current.setButtonDisabled("delete", true);
            toolbarRef.current.setButtonDisabled("generate", true);
        }

    }

    generateDocuments = () => {

        let url = "api/sims/learnerHETLecturerSupport/GenerateLearnerHETAgreement?Id=" + this.state.selectedLearnerHETLecturerSupport[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            this.setState({ selectedLearnerSkillsProgram: null, clearSelectedRow: true })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    FileDownload = (documentName) => {

        utils.invokeUrl("api/sims/learnerHETLecturerSupport/DownloadLearnerAgreement?FileName=" + documentName, (response) => {

            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
        }, (e) => {
            this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
        }
        );

    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedLearnerHETLecturerSupport: selection })

            let url = "api/sims/LearnerHETLecturerSupport/CheckCanEditProgramme?Id=" + selection[0].Id;
            utils.invokeUrl(url, (response) => {
                toolbarRef.current.setButtonDisabled("edit", response.Result === "0" ? true : false)
                if (selection[0].ProgrammeStatus === "Completed" || selection[0].ProgrammeStatus === "Registered") {
                    toolbarRef.current.setButtonDisabled("delete", true)
                }
                else {
                    toolbarRef.current.setButtonDisabled("delete", false)
                }
            },
                (e) => {
                    toolbarRef.current.setButtonDisabled("edit", true)
                },
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    }
                }
            )
        }
        else {
            this.setState({ selectedLearnerHETLecturerSupport: null })
        }
    }


    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {`Learner > HET Lecturer Support Programmes > ${this.props.location.state.learnerNames}`}
                </p>
                <SearchView headCells={headCells} dataUrl={utils.isNull(this.props.dataUrl) ? "api/sims/learnerHETLecturerSupport/GetLearnerHETLecturerSupportSearch" : this.props.dataUrl}
                    deleteUrl={"api/sims/learnerHETLecturerSupport/unlinkLearnerHETLecturerSupport"} useDeletePost={true}
                    entityViewPath='/AddLearnerHETLecturerSupport'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    toolbarRef={toolbarRef}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="HETLecturerSupportProgrammeDescription" mode={this.props.mode}
                    history={this.props.history} multiSelect={this.props.multiSelect}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch}
                    setSelection={(selection) => { this.handleSelection(selection) }}
                    promptTitle={"Remove Learner HETLecturerSupport"}
                    promptContent={"Are you sure you want to remove the learner HETLecturerSupport record?"}
                >
                    <HETLecturerSupportSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(LearnerHETLecturerSupport));

